module.exports = __webpack_public_path__ + "static/media/read.4ee8e8f0.png";